import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

createRoot(document.getElementById("root")!).render(<App />);

/**
 * Service Worker — registro condicional e seguro.
 *
 * Só registra quando:
 *  - estamos em produção (não em preview / iframe / localhost)
 *  - o navegador suporta SW
 *
 * Em preview/iframe, removemos qualquer SW antigo para evitar cache stale
 * dentro do editor do Lovable.
 */
(() => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  const inIframe = (() => {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  })();

  const host = window.location.hostname;
  const isPreview =
    host.includes("lovableproject.com") ||
    host.includes("id-preview--") ||
    host === "localhost" ||
    host === "127.0.0.1";

  if (inIframe || isPreview) {
    // Limpa SWs antigos para garantir que o preview sempre receba HTML fresco.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        console.warn("[sw] registration failed", err);
      });
  });
})();
